import React, { useState } from "react";
import { useSelector } from "react-redux";
import CareerCouncilingHeader from ".././careerCounciling/CareerCounselingHeader";
import ManageStudentsPage from "../careerCounciling/ManageStudentsPage";
import Statistics from "../careerCounciling/Statistics";

const CareerCounciling = () => {
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const [activeTab, setActiveTab] = useState("students"); // Default tab

  // Function to handle tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="flex">
      {/* Main Content */}
      <div
        className={`flex-1 bg-gray-50 ${
          isSideBarOpen ? "ml-80" : "ml-24"
        } min-h-screen`}
      >
        {/* Header Section */}
        <div className="bg-white border-b border-gray-200 shadow-sm">
          {/* Career Counseling Header */}
          <CareerCouncilingHeader />
        </div>

        {/* Tabs Navigation */}
        <div className="bg-white border-b border-gray-200 px-6 py-2 sticky top-0 z-10 shadow-sm">
          <div className="max-w-7xl mx-auto">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              <button
                onClick={() => handleTabChange("students")}
                className={`${
                  activeTab === "students"
                    ? "border-purple-600 text-purple-700"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 flex items-center`}
                aria-current={activeTab === "students" ? "page" : undefined}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`mr-2 h-5 w-5 ${
                    activeTab === "students"
                      ? "text-purple-600"
                      : "text-gray-400"
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                </svg>
                Manage Students
              </button>
              <button
                onClick={() => handleTabChange("statistics")}
                className={`${
                  activeTab === "statistics"
                    ? "border-purple-600 text-purple-700"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 flex items-center`}
                aria-current={activeTab === "statistics" ? "page" : undefined}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`mr-2 h-5 w-5 ${
                    activeTab === "statistics"
                      ? "text-purple-600"
                      : "text-gray-400"
                  }`}
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                  <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                </svg>
                Statistics
              </button>
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="p-6 max-w-7xl mx-auto">
          {activeTab === "students" && <ManageStudentsPage />}
          {activeTab === "statistics" && <Statistics />}
        </div>
      </div>
    </div>
  );
};

export default CareerCounciling;
